require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 281
// module chunks = 21